const urlRegExp = /(https?:\/\/[^\s]+)/g;

export default urlRegExp;
